<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>
<h2 id="title">Pazienti inattivi sulla piattaforma</h2>
<div class="container && mat-elevation-z5">
  <ng-container>
    <div id="container">
      <p id="descrizioneInattivi">Di seguito sono presenti gli utenti classificati come "inattivi". <br>
      Vengono considerati utenti inattivi i pazienti che non si collegano alla piattaforma da almeno 4 mesi se seguiti in telemedicina, oppure da almeno 7 mesi se seguiti con cure tradizionali</p>
      <div *ngIf="notReady==false && this.inactivePatients.length==0">
        <h3 id="inactivePatientEmpty">Non sono presenti pazienti inattivi</h3>
      </div>
      <div *ngIf="!(notReady==false && this.inactivePatients.length==0)">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Nome paziente </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="surname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Cognome paziente </th>
          <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Categoria </th>
          <td mat-cell *matCellDef="let element"> {{element.category}} </td>
        </ng-container>

        <ng-container matColumnDef="lastLogin">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Ultimo accesso </th>
          <!-- lo split serve perche non voglio vedere l'orario. La data mi arriva in formato aaaa/mm/ggTorario-->
          <td mat-cell *matCellDef="let element"> {{element.lastLogin.split("T")[0]}} </td>
        </ng-container>

        <ng-container matColumnDef="card">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let patient">
            <span><button mat-button mat-icon-button matTooltip="Visualizza scheda paziente" color="primary" (click)="openPanel(patient)"><mat-icon>perm_identity</mat-icon></button></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="questionnaires">
          <th mat-header-cell *matHeaderCellDef><!-- Questionari--></th>
          <td mat-cell *matCellDef="let patient">
            <span><button mat-button mat-icon-button matTooltip="Visualizza questionari compilati" color="primary" (click)="goToQuestionnaires(patient)"><mat-icon>assignment</mat-icon></button></span>
          </td>
       </ng-container>

       <ng-container matColumnDef="remove">
         <th mat-header-cell *matHeaderCellDef><!--Rimuovi--></th>
         <td mat-cell *matCellDef="let patient">
           <span><button mat-button mat-icon-button matTooltip="Elimina paziente dalla piattaforma" color="warn"  (click)="openDeleteDialog(patient)"><mat-icon>delete</mat-icon></button></span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let patient; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="notReady==true">
        <mat-progress-bar mode="query"></mat-progress-bar>
      </div>
      <span>
      <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </span>
    </div>
    </div>
  </ng-container>
</div>
